<mat-toolbar class="mainNavbar">
  <div *ngIf="!isHandset" class="mainNavbar_item mainNavbar_item--logoWrapper" [routerLink]="['/']">
    <svg
      class="d-lg-none mainNavbar-logoImg"
      x="0px"
      y="0px"
      viewBox="0 0 145.7 93"
      enable-background="new 0 0 145.7 93"
      xml:space="preserve"
    >
      <path
        fill="#1D1D1B"
        d="M62.1,17.4H74c6.7,0,12.1,1.6,16.2,4.7c4,2.8,6.3,7.4,6.2,12.3c0,5.1-2.2,9.3-6.5,12.8
     c-4.3,3.4-10.9,5.1-19.8,5v24.3h-8L62.1,17.4z M70.1,24.5v20.7c6.1-0.1,10.5-0.9,13.5-2.6c2.9-1.6,4.6-4.7,4.4-8
     c0-2.8-1.2-5.4-3.3-7.1C82.4,25.5,77.6,24.5,70.1,24.5L70.1,24.5z"
      />
      <path
        fill="#1D1D1B"
        d="M109.9,17.4h12.8c6.4,0,11.6,1.6,15.6,4.8c3.8,2.9,6.1,7.4,6,12.2c0,3.9-1.3,7.6-3.9,10.5
     c-2.6,3-6.6,5.2-12.1,6.4l17.2,25.3h-9.3l-16.4-24.3H118v24.3h-8.1L109.9,17.4L109.9,17.4z M118,24.6v20.6
     c11.9,0.2,17.8-3.2,17.8-10.4c0.1-2.2-0.6-4.4-2.1-6.1c-1.5-1.6-3.4-2.8-5.6-3.2C124.9,24.8,121.4,24.5,118,24.6z"
      />
      <path
        fill="#1D1D1B"
        d="M47.9,47c0-7.7-3-15-8.3-20.5c-5.5-6-14-9-25.3-9H0v59.1h8.1V25.3h4.1c6,0,10.8,0.6,14.4,1.9
     c3.8,1.4,7,4,9.2,7.4c2.5,3.6,3.9,7.9,3.9,12.3c0,3.5-0.8,6.9-2.4,10c-1.5,2.9-3.8,5.4-6.5,7.3c-2.6,1.8-5.5,3-8.6,3.6
     c-2,0.3-3.9,0.5-5.9,0.6v8.1c10.1-0.3,17.8-3.3,23.2-8.9C45,61.6,47.9,54.7,47.9,47z"
      />
    </svg>
    <svg
      class="d-none d-lg-block mainNavbar-logoImg"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 524 93"
      xml:space="preserve"
    >
      <g>
        <path fill="#1D1D1B" d="M340.5,0h4.3v93.4h-4.3V0z" />
        <path fill="#1D1D1B" d="M0,17.3h8v51.1h19.2v8H0V17.3z" />
        <path
          fill="#1D1D1B"
          d="M102.6,17.4h8.1v36.3c0,5.4,1.3,9.5,3.9,12.5c2.6,2.9,6.2,4.4,11,4.4c4.7,0,8.3-1.3,11-4c2.7-2.7,4-6.5,3.9-11.4V17.4h8.1
            v37.2c0,7.2-2.1,13-6.2,17.3c-4.1,4.3-9.6,6.5-16.5,6.5c-7,0-12.6-2.2-16.9-6.6s-6.3-10.9-6.3-19.4L102.6,17.4z"
        />
        <path fill="#1D1D1B" d="M161.9,17.3H198v8.1h-14.1v51h-8v-51h-14V17.3z" />
        <path fill="#1D1D1B" d="M211.8,17.3h32.8v8.1h-24.8v14.8h24.8v8h-24.8v20.3h24.8v8h-32.8V17.3z" />
        <path
          fill="#1D1D1B"
          d="M307,19.4v9.1c-6.4-3.1-12.2-4.7-17.6-4.7c-6.4-0.2-12.7,2.2-17.4,6.6c-4.6,4.2-7.2,10.1-7.1,16.3
            c-0.1,6.3,2.5,12.3,7.2,16.5c4.8,4.4,10.8,6.6,18.1,6.6c5.3,0,10.8-1.7,16.7-5V74c-5.4,2.8-11.3,4.3-17.4,4.3
            c-8.8,0.2-17.2-3.2-23.5-9.3c-6.3-5.7-9.8-13.9-9.7-22.4c-0.1-8.4,3.4-16.4,9.6-22c6.2-6,14.5-9.3,23.1-9.2
            C295.3,15.5,301.3,16.9,307,19.4z"
        />
        <polygon
          fill="#1D1D1B"
          points="65.9,15 61.7,24.3 65.9,33.5 65.9,33.5 75.4,54.6 48.1,54.6 45.1,61.3 53.4,61.3 78.5,61.3 85.3,76.4 93.8,76.4
                "
        />
        <path
          fill="#1D1D1B"
          d="M440.4,17.4h11.9c6.7,0,12.1,1.6,16.2,4.7c4,2.8,6.3,7.4,6.2,12.3c0,5.1-2.2,9.3-6.5,12.8c-4.3,3.4-10.9,5.1-19.8,5v24.3
            h-8L440.4,17.4z M448.4,24.5v20.7c6.1-0.1,10.5-0.9,13.5-2.6c2.9-1.6,4.6-4.7,4.4-8c0-2.8-1.2-5.4-3.3-7.1
            C460.7,25.5,455.9,24.5,448.4,24.5L448.4,24.5z"
        />
        <path
          fill="#1D1D1B"
          d="M488.2,17.4H501c6.4,0,11.6,1.6,15.6,4.8c3.8,2.9,6.1,7.4,6,12.2c0,3.9-1.3,7.6-3.9,10.5c-2.6,3-6.6,5.2-12.1,6.4
            l17.2,25.3h-9.3l-16.4-24.3h-1.8v24.3h-8.1V17.4z M496.3,24.6v20.6c11.9,0.2,17.8-3.2,17.8-10.4c0.1-2.2-0.6-4.4-2.1-6.1
            c-1.5-1.6-3.4-2.8-5.6-3.2C503.2,24.8,499.7,24.5,496.3,24.6z"
        />
        <path
          fill="#1D1D1B"
          d="M426.2,47c0-7.7-3-15-8.3-20.5c-5.5-6-14-9-25.3-9h-14.3v59.1h8.1V25.3h4.1c6,0,10.8,0.6,14.4,1.9c3.8,1.4,7,4,9.2,7.4
            c2.5,3.6,3.9,7.9,3.9,12.3c0,3.5-0.8,6.9-2.4,10c-1.5,2.9-3.8,5.4-6.5,7.3c-2.6,1.8-5.5,3-8.6,3.6c-2,0.3-3.9,0.5-5.9,0.6v8.1
            c10.1-0.3,17.8-3.3,23.2-8.9C423.3,61.6,426.2,54.7,426.2,47z"
        />
      </g>
    </svg>
  </div>

  <button
    *ngIf="isHandset"
    mat-flat-button
    color="primary"
    class="button--square buttonHamburger"
    (click)="toggleSidebar()"
  >
    <mat-icon svgIcon="menu"></mat-icon>
  </button>
  <div
    class="mainNavbar_item mainNavbar_item--subprojectPickerWrapper border-right"
    *ngIf="shouldDisplaySubprojectPicker"
  >
    <app-subproject-picker
      [subprojects]="userDetails?.subprojects"
      [selectedSubproject]="userDetails?.selectedSubproject"
      [isAppOnline]="isAppOnline$ | async"
      [isHandset]="isHandset"
      (selected)="selectSubproject($event)"
    ></app-subproject-picker>
  </div>

  <div class="mainNavbar_item mainNavbar_item--rightSide">
    <app-online
      *ngIf="shouldDisplayAppOnline"
      [isAppOnlineRealState]="isAppOnlineRealState$ | async"
      [isAppLockedInOffline]="isAppLockedInOffline$ | async"
      (setAppLockedInOffline)="setAppLockedInOffline($event)"
    ></app-online>

    <ng-container *ngIf="!isHandset">
      <ng-container *ngIf="userDetails; else signOutTemplate">
        <button
          data-testId="open-user-preferences"
          mat-icon-button
          class="m-2 button--square button--small"
          (click)="openUserPreferencesDialog()"
        >
          <mat-icon class="icon--large" svgIcon="account-cog"></mat-icon>
        </button>
        <app-client-support
          [clientSupport]="userDetails?.clientSupport"
          [isAppOnline]="isAppOnline$ | async"
        ></app-client-support>
        <app-module-picker
          [ngClass]="{'cursor-notallowed': (isAppOnline$ | async) === false}"
          [accountType]="userDetails?.accountType"
          [modules]="userDetails?.modules"
          [selectedClient]="selectedClient$ | async"
          [isAppOnline]="isAppOnline$ | async"
          (selected)="selectModule($event)"
        ></app-module-picker>
        <app-account-details
          [baseAccount]="baseAccount$ | async"
          [selectedClient]="selectedClient$ | async"
          [clientsList]="userDetails?.clientsList"
          [isAppOnline]="isAppOnline$ | async"
          (selected)="selectClient($event)"
          (goToMyAccount)="goToMyAccount()"
          (signOut)="signOut()"
        ></app-account-details>
      </ng-container>
      <ng-template #signOutTemplate>
        <button
          matTooltip="Signing out is not possible in offline mode"
          [matTooltipDisabled]="isAppOnline$ | async"
          i18n-matTooltip="@@shared.header.btnSignOutOffline"
          [disabled]="(isAppOnline$ | async) === false"
          mat-button
          class="userProfile_signOutBtn"
          (click)="signOut()"
        >
          <mat-icon svgIcon="logout"></mat-icon>
          <span i18n="@@shared.header.btnSignOut">Sign out</span>
        </button>
      </ng-template>
    </ng-container>
  </div>
</mat-toolbar>
